var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"videos"},[_c('div',{staticClass:"wrapper"},[_c('playlists')],1),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.$auth.isAuthenticated()),expression:"!$auth.isAuthenticated()"}]},[_c('landing-footer')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }